import IEdgeData from "./IEdgeData";

class Edges {
  
  public static instance: Edges | null = null;

  private path: string;
  private mChildren: { [id: string]: IEdgeData };

  private constructor(path: string) {
    this.path = path;
    this.mChildren = {};
  }

  public static init(path: string): void {
    if (Edges.instance == null) {
      Edges.instance = new Edges(path);
    }
  }

  public request(): Promise<string | void> {
    return fetch(this.path)
      .then((response: Response) => response.json())
      .then((json: IEdgeData[]) => {
        this.mChildren = {};
        for (let child of json) {
          // Use the first override name if it exists
          if (child.OverrideNames != null) {
            if (child.OverrideNames.length > 0) {
              child.Name = child.OverrideNames[0];
            }
          }
          this.mChildren[child.ID] = child;
        }

        return new Promise<string>(
          (resolve, reject) => {
            resolve("Fetching Edges ready!");
            reject("Fetching Edges failed!");
          }
        );
      })
      .catch((error: any) => {
        console.error("Error loading JSON:", error);
      });
  }

  public findByID(id: string): IEdgeData | null {
    const child = this.mChildren[id];
    return (child ? child : null);
  }

  public first(): IEdgeData | null {
    const first = this.mChildren[Object.keys(this.mChildren)[0]];
    return (first ? first : null);
  }

  public children(): IEdgeData[] {
    return Object.values(this.mChildren);
  }
}

export default Edges;
